import pxToRem from "../../functions/pxToRem";

export default function inputLabel({ colors, typography }) {
  const { info, grey, error, background } = colors;
  const { size, fontWeightMedium } = typography;

  const inputLabel = {
    styleOverrides: {
      root: {
        fontSize: size.sm,
        color: grey[600],
        fontWeight: fontWeightMedium,
        lineHeight: 1.4,
        transform: `translate(${pxToRem(14)}, ${pxToRem(14)}) scale(1)`,
        transition: "color 200ms ease-in-out, transform 200ms ease-in-out",

        "&.Mui-focused": {
          color: info.main,
          fontWeight: fontWeightMedium,
        },

        "&.Mui-error": {
          color: error.main,
        },

        "&.MuiInputLabel-shrink": {
          transform: `translate(${pxToRem(14)}, ${pxToRem(-9)}) scale(0.75)`,
          lineHeight: 1.5,
          fontSize: size.md,
          backgroundColor: background.paper,
          padding: `0 ${pxToRem(4)}`,
          marginLeft: pxToRem(-4),

          "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
            fontSize: "0.85em",
          },
        },
      },

      sizeSmall: {
        fontSize: size.xs,
        lineHeight: 1.625,
        transform: `translate(${pxToRem(14)}, ${pxToRem(10)}) scale(1)`,

        "&.MuiInputLabel-shrink": {
          transform: `translate(${pxToRem(14)}, ${pxToRem(-7)}) scale(0.75)`,
          lineHeight: 1.6,
          fontSize: size.sm,

          "~ .MuiInputBase-root .MuiOutlinedInput-notchedOutline legend": {
            fontSize: "0.72em",
          },
        },
      },
    },
  };

  return inputLabel;
}
